import {
  useQuery, useMutation, useQueryClient 
} from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  getAvailableSourcingEvents,
  getSupplierBids,
  submitBid,
  withdrawBid,
  type SubmitBidRequest,
} from '../api/sourcing-client';

// Supplier ID and delivery zones will be retrieved from auth context and supplier profile in production
const MOCK_SUPPLIER_ID = 'sup-sysco';
const MOCK_DELIVERY_ZONES = ['Port of Miami', 'Port Everglades'];

export function useAvailableSourcingEvents() {
  return useQuery({
    queryKey: ['sourcing-events', 'available', MOCK_DELIVERY_ZONES],
    queryFn: () => getAvailableSourcingEvents(MOCK_DELIVERY_ZONES),
    // Refetch frequently for live auctions
    refetchInterval: 10000,
  });
}

export function useSupplierBids() {
  return useQuery({
    queryKey: ['supplier-bids', MOCK_SUPPLIER_ID],
    queryFn: () => getSupplierBids(MOCK_SUPPLIER_ID),
  });
}

export function useSubmitBid() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: Omit<SubmitBidRequest, 'supplierId'>) =>
      submitBid({
        ...request,
        supplierId: MOCK_SUPPLIER_ID 
      }),
    onSuccess: () => {
      toast.success('Bid submitted successfully');
      queryClient.invalidateQueries({ queryKey: ['supplier-bids'] });
      queryClient.invalidateQueries({ queryKey: ['sourcing-events'] });
    },
    onError: (error) => {
      toast.error(`Failed to submit bid: ${error.message}`);
    },
  });
}

export function useWithdrawBid() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: withdrawBid,
    onSuccess: () => {
      toast.success('Bid withdrawn');
      queryClient.invalidateQueries({ queryKey: ['supplier-bids'] });
    },
    onError: (error) => {
      toast.error(`Failed to withdraw bid: ${error.message}`);
    },
  });
}
